export default __webpack_public_path__ + "justhatched-devices_mobile.3d396a78.png";